import React from "react";
import styled from "styled-components";
import {asLocalTime} from "../../../../util/timeDescription";
import {timeBetween} from "../../../contribute/idea/timeOpenCalculator";
import {TargetPrice} from "./TargetPrice";
import {Commentary} from "./Commentary";
import {StopLoss} from "./StopLoss";
import {WebLink} from "./WebLink";
import {Attachments} from "./Attachments";
import {isUnrestricted} from "../../../restrictions/restrictions";

const Container = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    min-width: 350px;
`;

const FieldContainer = styled.div`
    display: flex;
    flex-grow: ${props => props.flexGrow || 0 };
    border-top: solid 0.5px #d6d0c8;
    padding-top: 7px;
    padding-left: 5px;
    padding-bottom: ${props => props.paddingBottom || "7px"};
`;

const FieldLabel = styled.div`
    flex-shrink: 0;
    width: 90px;
    font-size: 12px;
    color: #4a4a4a;
`;

const Field = ({fieldLabel, children, paddingBottom, flexGrow}) => {
    return <FieldContainer paddingBottom={paddingBottom} flexGrow={flexGrow}>
        <FieldLabel>{fieldLabel}</FieldLabel>
        {children}
    </FieldContainer>
};

const RestrictedCodesRow = ({idea}) => {
    if (isUnrestricted(idea)) {
        return null;
    }
    return <FieldContainer>
        <FieldLabel>Restriction Code</FieldLabel>
        <div className="t-restriction-codes">{idea.restrictionCodes.join(", ")}</div>
    </FieldContainer>
};

export const IdeaDetailsFields = ({idea, clock}) => {
    return <Container>
        <RestrictedCodesRow idea={idea}/>
        <Field fieldLabel="Time Created">
            <div className="t-created-date">{asLocalTime(idea.openDateTime, clock)}</div>
        </Field>
        <Field fieldLabel="Time Open">
            <div className="t-time-open">{timeBetween(idea.openDateTime, idea.closeDateTime, clock)}</div>
        </Field>
        <Field fieldLabel="Time Horizon">
            <div className="t-time-horizon">{idea.timeHorizon || "\u2014"}</div>
        </Field>
        <Field fieldLabel="Target Price">
            <TargetPrice idea={idea}/>
        </Field>
        <Field fieldLabel="Stop Loss Alert">
            <StopLoss idea={idea}/>
        </Field>
        <Field fieldLabel="Web Link">
            <WebLink idea={idea}/>
        </Field>
        <Field fieldLabel="Attachment" paddingBottom="none">
            <Attachments idea={idea}/>
        </Field>
        <Field fieldLabel="Commentary" flexGrow={1}>
            <Commentary idea={idea}/>
        </Field>
    </Container>;
};
